import wrapError from "@/components/helpers/wrapError"

export const apiAssignAccessRequest = (params, success, error) => {
  $.ajax({
    type: "POST",
    url: "/api/internal/rootAccessRequestManager",
    dataType: "json",
    processData: false,
    contentType: "application/json; charset=utf-8",
    data: JSON.stringify(params),
    success,
    error: wrapError(error, "apiAssignAccessRequest"),
  })
}

export const apiGetInternalAccessRequests = (success, error) => {
  $.ajax({
    type: "GET",
    url: "/api/internal/rootAccessRequestManager",
    success,
    error: wrapError(error, "apiGetInternalAccessRequests"),
  })
}
